"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSongwriterMyWriterCriteria = void 0;
const songwriter_writer_search_store_1 = __importStar(require("@App/stores/search/songwriter-writer-search-store"));
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
exports.defaultSongwriterMyWriterCriteria = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(songwriter_writer_search_store_1.songwriterLinkSearchOptions[0], true, true, undefined),
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(songwriter_writer_search_store_1.songwriterLinkSearchOptions[1], true, true, undefined),
];
class SongwriterMyWriterSearchStore extends songwriter_writer_search_store_1.default {
    constructor(rootStore) {
        super(rootStore);
        Object.defineProperty(this, "canAddCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "searchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        super.setSearchFilters({ inCatalogFilter: 'onlyWritersInCatalog' });
    }
    createWriterSearchCriteriaStore() {
        return new search_criteria_store_1.default(exports.defaultSongwriterMyWriterCriteria, songwriter_writer_search_store_1.songwriterLinkSearchOptions, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.some, 2);
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = this.createWriterSearchCriteriaStore();
    }
    setCurrentSearchFilters(filters) {
        super.setSearchFilters(filters);
    }
    resetStore() {
        super.resetStore();
        super.setSearchFilters({ inCatalogFilter: 'onlyWritersInCatalog' });
    }
}
exports.default = SongwriterMyWriterSearchStore;
